var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimulateurBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 730,
    viewBox: "0 0 1440 730",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8649_25714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25 686L-25 692L1499 692L1499 686L-25 686Z",
    fill: "#D6E5FF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25 395L-25 401L1499 401L1499 395L-25 395Z",
    fill: "#D6E5FF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25 112L-25 118L1499 118L1499 112L-25 112Z",
    fill: "#D6E5FF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.9922 762.387C-24.9922 762.387 112.374 544.971 205.552 557.577C375.424 580.475 442.169 518.141 505.849 439.328C569.529 360.457 660.567 360.457 712.101 390.814C763.693 421.114 819.623 567.638 935.068 560.757C1053.87 553.703 1017.37 110.14 1159.54 111.932C1300.55 113.725 1246.82 662.295 1400.67 641.074C1554.52 619.853 1570.54 627.254 1637.29 700.054C1637.29 700.054 1670.48 757.935 1801.08 760.826",
    fill: "url(#paint0_linear_8649_25714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.9908 766.377C-25.7427 766.377 -26.4946 766.203 -27.1308 765.741C-28.9816 764.584 -29.56 762.098 -28.4032 760.248C-22.7351 751.285 111.624 540.923 206.016 553.587C374.789 576.311 440.146 514.093 502.67 436.784C565.135 359.416 656.289 353.345 714.069 387.345C731.479 397.579 748.772 419.726 768.727 445.457C808.924 497.093 858.839 561.22 934.723 556.767C988.166 553.587 1009.05 453.957 1031.14 348.487C1055.89 230.239 1081.46 108 1158.56 108C1158.85 108 1159.19 108 1159.48 108C1231.32 108.925 1253.59 237.235 1277.18 373.12C1300.61 508.08 1324.84 647.665 1400.09 637.199C1555.04 615.805 1572.8 623.9 1640.18 697.451L1640.7 698.145C1641.05 698.723 1674.77 754.118 1801.14 756.952C1803.34 756.952 1805.08 758.86 1805.08 761.057C1805.08 763.254 1803.17 764.873 1800.97 764.989C1673.9 762.156 1637.58 708.322 1634.05 702.598C1569.38 632.111 1554.98 623.958 1401.25 645.179C1318.25 656.628 1293.44 513.226 1269.38 374.508C1247.4 247.817 1224.67 116.847 1159.48 116.037C1159.19 116.037 1158.96 116.037 1158.67 116.037C1088.05 116.037 1063.12 235.038 1039.06 350.164C1016.33 458.699 994.875 561.277 935.301 564.805C855.311 569.546 803.834 503.512 762.48 450.43C742.988 425.392 726.157 403.767 710.078 394.341C665.774 368.321 575.604 359.416 508.974 441.93C444.947 521.206 377.854 584.985 205.033 561.624C115.383 549.655 -20.248 762.329 -21.5783 764.526C-22.3302 765.741 -23.6605 766.377 -24.9908 766.377Z",
    fill: "url(#paint1_linear_8649_25714)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1158,
    cy: 110,
    r: 18,
    fill: "#75C5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8649_25714",
    x1: 888.046,
    y1: 111.874,
    x2: 888.046,
    y2: 762.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D3FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0074E4",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8649_25714",
    x1: -28.9816,
    y1: 437.131,
    x2: 1805.02,
    y2: 437.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578126,
    stopColor: "#92D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#219CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8649_25714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1834,
    height: 874,
    fill: "white",
    transform: "translate(-114)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulateurBg);
export default __webpack_public_path__ + "static/media/simulateur_bg.31d8c5dea19e099efa9ba91524bb63dc.svg";
export { ForwardRef as ReactComponent };